<template>
  <div class="index">
    <!--  <div class="status-list">
      <div class="status-item" :class="status_nav == 0 ? 'active' : ''" @click="status_nav = 0">已审核</div>
      <div class="status-item" :class="status_nav == 1 ? 'active' : ''" @click="status_nav = 1">未审核</div>
      <div class="status-item" :class="status_nav == 2 ? 'active' : ''" @click="status_nav = 2">审核失败</div>
    </div> -->
    <div class="nav-list">
      <div class="nav-item" :class="nav == 0 ? 'active' : ''" @click="check_nav(0)">
        文章
        <div class="num">{{ count.nav0 || 0}}</div>
      </div>
      <div class="nav-item" :class="nav == 1 ? 'active' : ''" @click="check_nav(1)">
        微心愿
        <div class="num">{{ count.nav1 || 0}}</div>
      </div>
      <div class="nav-item" :class="nav == 2 ? 'active' : ''" @click="check_nav(2)">
        爱心妈妈
        <div class="num">{{ count.nav2 || 0}}</div>
      </div>
      <div class="nav-item" :class="nav == 3 ? 'active' : ''" @click="check_nav(3)">
        困境儿童
        <div class="num">{{ count.nav3 || 0}}</div>
      </div>
    </div>

    <template v-if="nav == 0">
      <div class="news-list">
        <div class="news-item" v-for="(item, index) in list" @click="goPage('/leader/news/' + item.id)">
          <div class="acea-row row-column row-between">
            <div class="news-title omit2">{{ item.title || '' }}</div>
            <div class="news-synopsis omit1">{{ item.synopsis || '' }}</div>
            <div class="news-time">{{ item.add_time || '' }}</div>
          </div>
          <div class="news-img">
            <img :src="item.image_input" alt="">
          </div>
        </div>
      </div>
    </template>
    <template v-if="nav == 1">
      <div class="hope-list">
        <div class="hope-item" v-for="(item, index) in list" @click="goPage('/leader/hope?id=' + item.id)">
          <div class="hope-user">
            <div>
              <div class="user-name">{{ item.nickname || '' }}</div>
              <div class="user-date">{{ item.add_time || '' }}</div>
            </div>
          </div>
          <div class="hope-intro omit2">{{ item.synopsis || '' }}</div>
          <div class="hope-address">
            <div class="iconfont icon-dizhi"></div>
            <div>{{ item.address || '' }}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="nav == 2">
      <div class="hope-list">
        <div class="hope-item" v-for="(item, index) in list">

          <div class="hope-msg omit2">姓名：{{ item.nickname || '' }}</div>
          <div class="hope-msg omit2">出生年月：{{ item.year_month || '' }}</div>
          <div class="hope-msg omit2">职业：{{ item.career || '' }}</div>
          <div class="hope-msg omit2">区域：{{ item.region || '' }}</div>
          <div class="hope-msg omit2">联系电话：{{ item.phone || '' }}</div>
          <div class="btn-box">
            <div class="confirm-btn" @click="confirmCheck(item.id)">通过</div>
            <div class="cancel-btn" @click="showCancel(item.id)">未通过</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="nav == 3">
      <div class="child-list">
        <div class="child-item" v-for="(item, index) in list" @click="goPage('/leader/child?id=' + item.id)">
          <div class="child-info">
            <img class="child-head" :src="item.image_input" alt="">
            <div>
              <div class="child-name">
                <div>{{ item.nickname || '' }}</div>
                <img class="gender-img" :src="`${require('@assets/images/dywfl/gender1.png')}`" alt=""
                  v-if="item.sex == '男'">
                <img class="gender-img" :src="`${require('@assets/images/dywfl/gender2.png')}`" alt="" v-else>
              </div>
              <div class="child-time">{{ item.add_time || '' }}</div>
            </div>
          </div>
          <div class="child-intro omit2">{{ item.synopsis || '' }}</div>
          <div class="child-address">
            <div class="iconfont icon-dizhi"></div>
            <div class="omit1">{{ item.address || '' }}</div>
          </div>
          <div class="info-btn">查看详情</div>
        </div>
      </div>
      <Loading :loaded="loaded" :loading="loading"></Loading>
    </template>

    <div class="mask" v-if="show_cancel" @click="show_cancel = !show_cancel"></div>
    <div class="cancel-window" v-if="show_cancel">
      <textarea placeholder="请输入未通过修改意见" v-model="advice"></textarea>
      <div class="btn-container">
        <div class="confirm-btn" @click="cancelCheck">未通过</div>
        <div class="cancel-btn" @click="show_cancel = !show_cancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@components/Loading";
import { getContents,Examine} from "@api/public";
export default {
  name: "content-list",
  components: {
	  Loading
  },
  props: {},
  data: function () {
    return {
      loaded: false,
      loading: false,
      status_nav: 0,
      nav: 0,
      list: [],
      count: [],
      show_cancel: false,
      advice: '',
      cancel_id: 0
    }
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    showCancel(id) {
      this.cancel_id = id;
	  this.show_cancel=!this.show_cancel;
    },
    confirmCheck(e) {
		if(e){
			this.$dialog.loading.open("正在加载中");
			let data={};
			data.id = e;
			data.nav = 2;
			data.is_leader_check_status=1;
			Examine(data).then(res => {
				this.$dialog.loading.close();
				this.$dialog.success(res.msg);
				setTimeout(() => {
					this.$router.go(0)
				}, 1000);
			}).catch(res=>{
				this.$dialog.loading.close();
				this.$dialog.error(res.msg);
			});  
	    }
    },
    cancelCheck() {
	  this.$dialog.loading.open("正在加载中");
	  let data={};
	    data.id = this.cancel_id;
	    data.nav = 2;
	    data.is_leader_check_status=2;
	    data.leader_check_fail_remarks=this.advice;
	  Examine(data).then(res => {
	  	this.$dialog.loading.close();
	  	this.$dialog.success(res.msg);
	  	setTimeout(() => {
	  	  this.$router.go(0)
	  	}, 1000);
	  }).catch(res=>{
	  	this.$dialog.loading.close();
	  	this.$dialog.error(res.msg);
	  });
    },
    getList() {
      let data = {};
      // data.status_nav=this.status_nav;
      data.nav = this.nav;
      getContents(data).then((res) => {
        this.list = res.data.list
        this.count = res.data.count
      }).catch(res => {
        this.$dialog.error(res.msg);
      });
    },
    check_nav(e) {
      this.nav = e;
	  this.list = [];
	  this.count=[];
      this.getList();
    },
    goPage(url) {
      this.$router.push({ path: url });
    }
  },
};
</script>
<style scoped>
body {
  background-color: #f7f7f7;
}
</style>
<style lang="scss" scoped>
.nav-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .4rem .3rem;
  border-bottom: 1px solid #f1f1f1;

  .nav-item {
    padding: .1rem;
    border-radius: 2rem;
    line-height: 1;
    min-width: 1.2rem;
    text-align: center;
    color: #F64272;
    border: 1px solid #F64272;
    position: relative;

    .num {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(50%, -50%);
      background-color: #F05877;
      border: 1px solid #fff;
      color: #fff;
      line-height: .32rem;
      height: .32rem;
      border-radius: .32rem;
      padding: 0 .1rem;
    }

    &.active {
      background-color: #F64272;
      color: #fff;
    }
  }
}

.status-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .2rem 0;
  border-bottom: 1px solid #f1f1f1;

  .status-item {
    flex: 1;
    text-align: center;

    &.active {
      color: #F64272;
    }
  }
}

.news-list {
  background-color: #fff;
  padding: 0 .2rem;

  .news-item {
    display: flex;
    justify-content: space-between;
    padding: .3rem 0;

    &~.news-item {
      border-top: 1px solid #D2D2D2;
    }

    .news-title {
      font-size: .28rem;
    }

    .news-synopsis {
      font-size: .24rem;
      color: #B9BCBE;
    }

    .news-time {
      font-size: .22rem;
      color: #B9BCBE;
    }

    .news-img {
      flex-shrink: 0;
      margin-left: .2rem;

      img {
        width: 1.85rem;
        height: 1.43rem;
        vertical-align: bottom;
        object-fit: cover;
        border-radius: .1rem;
      }
    }
  }
}

.hope-list {
  // margin: 0 .2rem;
}

.hope-item {
  background-color: #fff;
  padding: .4rem 0 .2rem;
  border-bottom: 1px solid #f1f1f1;

  .hope-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .6rem;

    .user-name {
      font-size: .26rem;
    }

    .user-date {
      font-size: .22rem;
      color: #999;
      margin-top: .05rem;
    }
  }

  .hope-status {
    width: 1.5rem;
    line-height: .5rem;
    border-radius: .5rem;
    font-size: .26rem;
    text-align: center;


    &.cancel {
      background-color: #EAEAEA;
    }

    &.confirm {
      background-color: #FCEAEF;
      color: #F64272;
    }
  }

  .hope-intro {
    padding: .25rem .6rem 0;
    font-size: .3rem;
  }

  .hope-msg {
    padding: .1rem .6rem 0;
    font-size: .28rem;
  }

  .btn-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: .2rem;
    padding: 0 .3rem;

    .confirm-btn,
    .cancel-btn {
      width: 48%;
      text-align: center;
      line-height: .7rem;
      border-radius: .6rem;
    }

    .confirm-btn {
      background-color: #F05877;
      color: #fff;
    }

    .cancel-btn {
      background-color: #C9C9C9;
    }
  }

  .hope-address {
    display: flex;
    align-items: center;
    padding: .25rem .6rem 0;
    font-size: .26rem;

    .iconfont {
      color: #B3B3B3;
      font-size: .3rem;
      margin-right: .2rem;
    }
  }

  .info-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: .86rem;
    color: #777;
    line-height: 1;
    border-top: 1px solid #FFE2E7;
    margin-top: .25rem;

    .iconfont {
      font-size: .24rem;
      margin-left: .2rem;
    }
  }
}

.child-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 .2rem;

  .child-item {
    width: calc(50% - .1rem);
    background-color: #fff;
    border-radius: .1rem;
    margin: .2rem 0;
    padding: .3rem .15rem;
    animation: fade_in .5s;
    border: 1px solid #F64272;

    .child-info {
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #C9C9C9;
      padding-bottom: .3rem;

      .child-head {
        width: .85rem;
        height: .85rem;
        border-radius: .1rem;
        margin-right: .2rem
      }

      .child-name {
        display: flex;
        align-items: flex-start;
        font-size: .28rem;
      }

      .child-time {
        font-size: .24rem;
        color: #999;
        margin-top: .05rem;
      }

      .gender-img {
        width: .16rem;
        height: .16rem;
      }
    }

    .child-intro {
      font-size: .26rem;
      color: #666;
      margin-top: .25rem;
    }

    .child-address {
      display: flex;
      align-items: center;
      font-size: .22rem;
      line-height: 1;
      margin-top: .25rem;

      .iconfont {
        font-size: .3rem;
        color: #B3B3B3;
      }
    }

    .info-btn {
      line-height: .49rem;
      text-align: center;
      background-color: #F05877;
      color: #fff;
      border-radius: .49rem;
      margin-top: .25rem;
    }
  }
}

.cancel-window {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: .3rem;
  z-index: 556;
  background-color: #fff;

  textarea {
    height: 1rem;
    border-radius: .3rem;
    border: 1px solid #F64272;
    width: 100%;
    height: 2rem;
    padding: .2rem;
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: .3rem;

    .confirm-btn,
    .cancel-btn {
      line-height: .9rem;
      text-align: center;
      font-size: .28rem;
      border-radius: .9rem;
      width: 48%;
    }

    .confirm-btn {
      background-color: #F64272;
      color: #fff;
    }

    .cancel-btn {
      background-color: #f7f7f7;
      color: #000;
    }
  }
}
</style>
